/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { parseDependencies } from './dependenciesParse.generated.js';
import { createParserClass } from '../../factoriesAny.js';
export var ParserDependencies = {
  parseDependencies,
  createParserClass
};